'use client';

import { usePathname } from 'next/navigation';
import { useLoader } from '../../core/contexts/LoaderContext';
import Loader from './Loader';

const GlobalLoader = () => {
  const { isLoading } = useLoader();
  const pathname = usePathname();

  // Never show loader on the password-protection page, the legal pages, or the
  // Payment-By-Link result page. These are standalone pages with no app-startup
  // flow to dispatch the 'splash-done' event, so the initial splash loader would
  // otherwise stay stuck on screen.
  if (
    pathname === '/password' ||
    pathname === '/terms-and-conditions' ||
    pathname === '/cookie-policy' ||
    pathname === '/checkout/payment-link-result'
  )
    return null;

  return isLoading ? <Loader /> : null;
};

export default GlobalLoader; 